import { FloatBarController } from "./FloatBarController";
import { FloorWidget } from "../../floors/FloorWidget";
import { PlanManager } from "../../cocosPlan";

interface EventMapping {
    id: string;
    event: string;
    handler: (event: any) => void;
}

interface Dropdown {
    button: string;
    menu: string;
}

export class FloatingBarWidget {
    floatBarController: FloatBarController;
    parent: HTMLElement;
    floorWidget: FloorWidget;
    
    sceneUploaded = (event: Event) => {
        const target = event.currentTarget as HTMLInputElement | null;
        if (target?.files?.[0]) this.floatBarController.CheckSceneUploaded(target.files[0]);
    }

    floorUploaded = (event: Event) => {
        const target = event.currentTarget as HTMLInputElement | null;
        if (target?.files?.[0]) this.floatBarController.CheckFloorUploaded(target.files[0], (target as any).floorToImportId);
    }

    selectionUploaded = (event: Event) => {
        const target = event.currentTarget as HTMLInputElement | null;
        if (target?.files?.[0]) this.floatBarController.CheckSelectionUploaded(target.files[0]);
    }

    camerasUploaded = (event: Event) => {
        const target = event.currentTarget as HTMLInputElement | null;
        if (target?.files?.[0]) this.floatBarController.CheckCamerasUploaded(target.files[0]);
    }
    
    save = (event: MouseEvent) => {
        if (this.floatBarController.disableSaveProject) return;
        this.floatBarController.exportRhinovFormat();
        event.stopPropagation();
    }


    undo = () => {
        this.floatBarController.undo();
    }

    redo = () => {
        this.floatBarController.redo();
    }

    fullscreen = (event: MouseEvent) => {
        this.floatBarController.fullscreen();
        event.stopPropagation();
    }

    grille = (event: MouseEvent) => {
        if (!this.floatBarController.getMustShowGrid()){
            (event.currentTarget as HTMLElement).classList.remove('deactivated');
        } else {
            (event.currentTarget as HTMLElement).classList.add('deactivated');
        }
        this.floatBarController.dispGrid();
    }

    mesures = (event: MouseEvent) => {
        if (!this.floatBarController.getMustShowArea()){
            (event.currentTarget as HTMLElement).classList.remove('deactivated');
        } else {
            (event.currentTarget as HTMLElement).classList.add('deactivated');
        }
        this.floatBarController.dispArea();
    }

    paperplan = (event: MouseEvent) => {
        if (!this.floatBarController.getMustShowPlan()){
            (event.currentTarget as HTMLElement).classList.remove('deactivated');
        } else {
            (event.currentTarget as HTMLElement).classList.add('deactivated');
        }
        this.floatBarController.dispPlan();
    }

    styleDropdowns = (event: MouseEvent) => {
        let dropdown = this.dropdowns.find(drop => drop.button === (event.currentTarget as HTMLElement).id);
        if (!dropdown) return;
        let menu = document.getElementById(dropdown.menu);
        if (!menu) return;
        if (menu.style.display === 'none') {
            this.handleDropdowns(event);
            menu.style.display = "block";
        } else this.handleDropdowns(event);
        event.stopPropagation();
    }

    handleDropdowns = (event: MouseEvent) => {
        this.dropdowns.forEach(({button, menu}) => {
            let elem = document.getElementById(menu);
            if (!elem) return;
            if (!elem.contains(event.target as Node) && elem.style.display !== 'none') {
                elem.style.display = 'none';
            }
        });
    }

    importElement = (event: Event) => {
        let menu = document.getElementById('importMenu');
        if (!menu) return;
        if ((event.currentTarget as HTMLElement).id === "importProject"){
            this.floatBarController.importRhinovFormat();
            menu.style.display = 'none';
            return;
        }
        if ((event.currentTarget as HTMLElement).id === "importCameras"){
            this.floatBarController.importRhinovFormatCameras();
            menu.style.display = 'none';
            return;
        }
        if ((event.currentTarget as HTMLElement).id === "importCurrentFloor"){
            this.floatBarController.importRhinovFormatSelection();
            menu.style.display = 'none';
            return;
        }
    }

    closeDropdown = (event: MouseEvent) => {
        let parent = (event.currentTarget as HTMLElement).parentElement;
        if (!parent) return;
        parent.style.display = 'none';
        event.stopPropagation();
    }
    
    
    exportElement = (event: Event) => {
        let exports = [
            {id: "exportDefault", handler: this.floatBarController.downloadRhinovFormat},
            {id: "exportWithoutDeco", handler: this.floatBarController.downloadRhinovFormatWithoutDeco},
            {id: "exportWithoutDecoKitchen", handler: this.floatBarController.downloadRhinovFormatWithoutDecoWithKitchen},
            {id: "exportCameras", handler: this.floatBarController.downloadRhinovFormatCameras},
            {id: "exportSelected", handler: this.floatBarController.downloadRhinovFormatSelection},
            {id: "exportSelectedWithoutswitch", handler: this.floatBarController.downloadRhinovFormatSelectionWithoutSwitch},
        ];
        let menu = document.getElementById('exportMenu');
        if (!menu) return;
        exports.forEach(({id, handler}) => {
            if ((event.currentTarget as HTMLElement).id === id) {
                handler.bind(this.floatBarController)()
                menu.style.display = 'none';
                ;
            }
        });
    }

    InputDispatch = (event: Event) => {
        var target = event.currentTarget as HTMLInputElement & { param?: string, controller?: CallableFunction}
        if (target.param) {
            (this.floatBarController as any)[target.param] = target.value;
        }
        if (target.type === "number" || target.type === "range") {
            if (target.controller) target.controller(target.value === "" ? null : Number(target.value));
            return;
        }
        if (target.type === "checkbox") {
           if (target.controller) target.controller(target.checked);
            return;
        }
        if (target.tagName === "SELECT") {
            if (target.controller) target.controller(target.value === "" ? null : Number(target.value));
            if (target.value === undefined) {
                target.classList.add("greyText")
            } else {
                target.classList.remove("greyText")
            }
            if (target.id === "selectObject") {
                this.destroyModeles();
                let modeleManage = document.getElementById('modeleManage');
                if (!modeleManage) return;
                modeleManage.innerHTML = this.ManageModeleChoice();
                this.setModeles();
                let preview = document.getElementById('previewImg') as HTMLImageElement;
                if (!preview) return;
                preview.src = this.floatBarController.itemPreview;
            }
        }
    }

    applyTranslate = () => {
        this.floatBarController.doTranslateProject();
    }

    applyRotate = () => {
        this.floatBarController.doRotateProject();
    }

    applyScale = () => {
        this.floatBarController.doScaleProject();
    }

    applyHeight = (event: Event) => {
        if ((event.currentTarget as HTMLElement).id === "applyHeight"){
            this.floatBarController.doSetFloorHeight();
            return;
        }
        this.floatBarController.doSetProjectFloorHeight();
    }

    applyFloorHeight = () => {
        this.floatBarController.doSetRoomFloorHeight();
    }

    symetry = (event: Event) => {
        if ((event.currentTarget as HTMLElement).id === "symetryHorizontal") {
            this.floatBarController.doSymetryProject('horizontal');
            return;
        }
        this.floatBarController.doSymetryProject('vertical');
    }

    initSettings = (event: MouseEvent) => {
        this.floatBarController.initSettings.bind(this.floatBarController)()
        this.styleDropdowns(event);
    }

    applyInOutdoor = (event: Event) => {
        let param = (event.currentTarget as HTMLElement).id === "applyIndoor";
        this.floatBarController.doApplyJoineryColor(Number(this.floatBarController.joineryDefaultColor), param);
    }

    updateModele = (event: Event) => {
        this.floatBarController.updateModeleType((event.currentTarget as HTMLElement & {param?: any}).param);
        let element = document.getElementById('previewImg') as HTMLImageElement;
        element.src = this.floatBarController.itemPreview;
    }

    doResetDefaultModels = () => {
        this.floatBarController.doResetDefaultModels();
        let preview = document.getElementById('previewImg') as HTMLImageElement;
        if (!preview) return;
        preview.src = this.floatBarController.itemPreview;
    }

    doSetFloorCornices = (event: Event) => {
        let param = (event.currentTarget as HTMLElement).id === "activateCurrentFloor";
        this.floatBarController.doSetFloorCornices(param);
    }

    doSetProjectCornices = (event: Event) => {
        let param = (event.currentTarget as HTMLElement).id === "activateProject";
        this.floatBarController.doSetProjectCornices(param);
    }

    zoom = (event: Event) => {
        if ((event.currentTarget as HTMLElement).id === "zoomIn") {
            this.floatBarController.zoomIN();
            return;
        }
        this.floatBarController.zoomOUT();
    }

    eventCustom = (event: Event) => {
        this.floatBarController.sendEvent((event.currentTarget as HTMLElement & { param?: any }).param);
    }
    
    
    dropdowns: Dropdown[] = [
        {button: "importButton", menu: "importMenu"},
        {button: "exportButton", menu: "exportMenu"},
        {button: "geometricButton", menu: "geometricMenu"},
        {button: "generalButton", menu: "generalMenu"},
        {button: "floorButton", menu: "floorMenu"}
    ]; 
    
    eventList: EventMapping[] = [
        {id: "format-rhinov-pick", event:'change', handler: this.sceneUploaded,},
        {id: "format-rhinovfloor-pick", event:'change', handler: this.floorUploaded},
        {id: "format-rhinovselection-pick", event:'change', handler: this.selectionUploaded},
        {id: "format-rhinovcameras-pick", event:'change', handler: this.camerasUploaded},
        {id: "saveProject", event:'click', handler: this.save},
        {id: "undo", event:'click', handler: this.undo},
        {id: "redo", event:'click', handler: this.redo},
        {id: "fullscreen", event:'click', handler: this.fullscreen},
        {id: "grille", event:'click', handler: this.grille},
        {id: "mesures", event:'click', handler: this.mesures},
        {id: "paperplan", event:'click', handler: this.paperplan},
        {id: "importButton", event:'click', handler: this.styleDropdowns},
        {id: "importProject", event:'click', handler: this.importElement},
        {id: "generalButton", event:'click', handler: this.initSettings},
        {id: "importCameras", event:'click', handler: this.importElement},
        {id: "importCurrentFloor", event:'click', handler: this.importElement},
        {id: "exportButton", event:'click', handler: this.styleDropdowns},
        {id: "exportDefault", event:'click', handler: this.exportElement},
        {id: "exportWithoutDeco", event:'click', handler: this.exportElement},
        {id: "exportWithoutDecoKitchen", event:'click', handler: this.exportElement},
        {id: "exportCameras", event:'click', handler: this.exportElement},
        {id: "exportSelected", event:'click', handler: this.exportElement},
        {id: "exportSelectedWithoutswitch", event:'click', handler: this.exportElement},
        {id: "geometricButton", event:'click', handler: this.styleDropdowns},
        {id: "closeGeometric", event:'click', handler: this.closeDropdown},
        {id: "applyTranslate", event:'click', handler: this.applyTranslate},
        {id: "applyRotate", event:'click', handler: this.applyRotate},
        {id: "applyScale", event:'click', handler: this.applyScale},
        {id: "applyHeight", event:'click', handler: this.applyHeight},
        {id: "applyHeightProject", event:'click', handler: this.applyHeight},
        {id: "applyFloorHeight", event:'click', handler: this.applyFloorHeight},
        {id: "symetryHorizontal", event:'click', handler: this.symetry},
        {id: "symetryVertical", event:'click', handler: this.symetry},
        {id: "closeSettings", event:'click', handler: this.closeDropdown},
        {id: "applyIndoor", event:'click', handler: this.applyInOutdoor},
        {id: "applyOutdoor", event:'click', handler: this.applyInOutdoor},
        {id: "resetModele", event:'click', handler: this.doResetDefaultModels},
        {id: "activateCurrentFloor", event:'click', handler: this.doSetFloorCornices},
        {id: "deactivateCurrentFloor", event:'click', handler: this.doSetFloorCornices},
        {id: "activateProject", event:'click', handler: this.doSetProjectCornices},
        {id: "deactivateProject", event:'click', handler: this.doSetProjectCornices},
        {id: "zoomIn", event:'click', handler: this.zoom},
        {id: "zoomOut", event:'click', handler: this.zoom},
        {id: "floorButton", event:'click', handler: this.styleDropdowns},
        {id: "closeFloor", event:'click', handler: this.closeDropdown},
    ];
    
    
    constructor(parent: HTMLElement, config: any, isDesigner: boolean, saveProjectFn: CallableFunction, planId: number, deliverableId: string) {
        this.parent = parent;
        this.floatBarController = new FloatBarController(config, isDesigner, saveProjectFn, planId, deliverableId, this.updateFloatBarWidget.bind(this));
        this.floorWidget = new FloorWidget(!this.floatBarController.config.add_floor, this.floatBarController.isDesigner, planId);
    }
    
    updateFloatBarWidget() {
        this.floorWidget.getHTMLId = !this.floatBarController.config.add_floor;
        this.destroyListener();
        this.floorWidget.removeFloorListener();
        this.parent.innerHTML = this.html();
        this.floorWidget.setFloorListener();
        this.setEventListenner();
        this.updateSaveProjectDisabledState();
    }

    updateSaveProjectDisabledState() {
        const saveButton = document.getElementById('saveProject');
        if (!saveButton) return;
        if (this.floatBarController.disableSaveProject) {
            saveButton.classList.add('disabled');
        } else {
            saveButton.classList.remove('disabled');
        }
    }

    addGeometryPrimitivs(event: Event) {
        const target = event.currentTarget as HTMLElement;
        const type = target.dataset.type
        this.floatBarController.addGeometryPrimitivs(type!);
    }
    
    setEventListenner() {
        let inputBoxs = [
            {id:"translateXInput", event:'input', param: 'translateX', controller: this.floatBarController.changeTranslateXProject},
            {id:"translateYInput", event:'input', param: 'translateY', controller: this.floatBarController.changeTranslateYProject},
            {id:"rotateInput", event:'input', param: 'rotationAngle', controller: this.floatBarController.changeRotationAngleProject},
            {id:"scaleInput", event:'input', param: 'scale', controller: this.floatBarController.changeScaleProject},
            {id:"floorHeightInput", event:'input', param: 'floorheight', controller: this.floatBarController.changeFloorHeight},
            {id:"roomfloorHeightInput", event:'input', param: 'roomfloorheight', controller: this.floatBarController.changeRoomFloorHeight},
            {id:"vectorDraw", event:'change', param: 'vectorDraw', controller: this.floatBarController.changeVectorDraw},
            {id:"opacityInput", event:'change', param: 'opacityValue', controller: this.floatBarController.changeOpacity},
            {id:"opacityFloorsInput", event:'change', param: 'floorOpacityValue', controller: this.floatBarController.changeOpacityFloors},
            {id:"selectJoineryColor", event:'change', param: 'joineryDefaultColor', controller: this.floatBarController.updateJoineryDefaultColor},
            {id:"selectObject", event:'change', param: 'currentObjectType', controller: this.floatBarController.updateObjectType},
        ];
        let GeoType = ["box", "cylinder", "oval", "halfarc", "hood", "triangle", "sphere"];

        GeoType.forEach(type => {
            let element = document.getElementById(`add_${type}`);
            if (!element) return;
            element.addEventListener('click', this.addGeometryPrimitivs.bind(this));
        })
        this.eventList.forEach(({id, event, handler}) => {
            let element = document.getElementById(id);
            if (!element) return;
            element.addEventListener(event, handler);
        });

        inputBoxs.forEach(({id, event, param, controller}: any) => {
            let element = document.getElementById(id) as HTMLInputElement & { param?: string, controller: CallableFunction };
            if (!element) return;
            element.value = (this.floatBarController as any)[param];
            element.controller = controller.bind(this.floatBarController);
            element.param = param;
            element.addEventListener(event, this.InputDispatch.bind(this));
        });
        this.setModeles();
        if (this.floatBarController.config.customs) {
            this.floatBarController.config.customs.forEach((custom: any, index: number) => {
                let element = document.getElementById(`custom-${index}`) as HTMLInputElement & { param?: string };
                if (!element) return;
                element.param = custom.event;
                element.addEventListener('click', this.eventCustom.bind(this))
            })
        }
        document.addEventListener('click', this.handleDropdowns);
    }

    setModeles() {
        this.floatBarController.allModelsForCurrentElement.forEach((modele: any, index: number) => {
            let element = document.getElementById(`modele-${index}`) as HTMLInputElement & { param?: any };
            if (!element) return;
            element.param = modele;
            element.addEventListener('click', this.updateModele.bind(this));
        })
    }


    destroyListener() {
        let inputBoxs = [
            {id:"translateXInput", event:'input'},
            {id:"translateYInput", event:'input'},
            {id:"rotateInput", event:'input'},
            {id:"scaleInput", event:'input'},
            {id:"floorHeightInput", event:'input'},
            {id:"roomfloorHeightInput", event:'input'},
            {id:"vectorDraw", event:'change'},
            {id:"opacityInput", event:'change'},
            {id:"opacityFloorsInput", event:'change'},
            {id:"selectJoineryColor", event:'change'},
            {id:"selectObject", event:'change'},
        ];
        this.eventList.forEach(({id, event, handler}: any) => {
            let element = document.getElementById(id);
            if (!element) return;
            element.removeEventListener(event, handler);
        });
        inputBoxs.forEach(({id, event}: any) => {
            let element = document.getElementById(id);
            if (!element) return;
            element.removeEventListener(event, this.InputDispatch);
        });
        this.destroyModeles();
        this.setModeles();
        if (this.floatBarController.config.customs) {
            this.floatBarController.config.customs.forEach((custom: any, index: number) => {
                let element = document.getElementById(`custom-${index}`);
                if (!element) return;
                element.removeEventListener('click', this.eventCustom.bind(this))
            })
        }
        document.removeEventListener('click', this.handleDropdowns);
    }

    destroyModeles() {
        this.floatBarController.allModelsForCurrentElement.forEach((modele: any, index: number) => {
            let element = document.getElementById(`modele-${index}`);
            if (!element) return;
            element.removeEventListener('click', this.updateModele.bind(this));
        })
    }

    destroy() {
        if (this.floorWidget && this.floorWidget.floorController){
            this.floorWidget.removeFloorListener();
            this.floorWidget.floorController.destroy();
        }
        this.destroyListener();
        if (this.floatBarController) {
            this.floatBarController.Destroy();
        }
    }

    html(): string {
        return `
            <div  id="floating-toolbar" class="btn-group-vertical floating-toolbar" style="position:absolute;left:0;top:7%;z-index:+5;">
                <input type="file" id="format-rhinov-pick" style="display:none" accept=".rhinov"/>
                <input type="file" id="format-rhinovfloor-pick" style="display:none" accept=".rhinovfloor"/>
                <input type="file" id="format-rhinovselection-pick" style="display:none" accept=".rhinovselection"/>
                <input type="file" id="format-rhinovcameras-pick" style="display:none" accept=".rhinovcameras"/>

                ${this.ManageSave()}
                ${this.ManageUndoRedo()}
                ${this.ManageGeneralParam()}
                <div id="floorContainer" title="Gestionnaire d'étages">
                    ${this.floatBarController.config.floors ? this.floorWidget.html() : ""}
                </div>
                ${this.ManageGeometricAdd()}
                ${this.ManageGeometricTool()}
                ${this.ManageZoom()}
                ${this.ManageFullscreen()}
                ${this.ManageDisplayOptions()}
                ${this.ManageImports()}
                ${this.ManageCustom()}
            </div>
            `;
    }

    ManageSave(): string {
        if (this.floatBarController.config.save) {
            return `
                <!-- SAVE -->
                    <button type="button" title="Sauvegarder" id="saveProject" class="btn btn-flat btn-default">
                        <i class="material-icons icon-FloatBar_Save"></i>
                    </button>

                    <div class="tool-separator" ></div>        
            `;
        }
        return "";
    }

    ManageUndoRedo(): string {
        if (this.floatBarController.config.undo_redo){
            return `
                <!-- UNDO/REDO -->
                <button id="undo" title="Défaire" type="button" class="btn btn-flat btn-default"">
                    <i class="material-icons icon-FloatBar_Undo"></i>
                </button>

                <div class="tool-separator mini"></div>

                <button id="redo" title= "Refaire" type="button" class="btn btn-flat btn-default">
                    <i class="material-icons icon-FloatBar_Redo"></i>
                </button>

                <div class="tool-separator"></div>
            `;
        }
        return "";
    }

    ManageFullscreen(): string {
        if (this.floatBarController.config.fullscreen){
            return `
                <!-- FULLSCREEN -->
                <button  type="button" title="Plein écran" id="fullscreen" class="btn btn-flat btn-default">
                    <i class="fas fa-lg fa-expand" aria-hidden="true"></i></button>
                <div class="tool-separator height-low-priority-1"></div>
            `;
        }
        return "";
    }

    ManageDisplayOptions(): string {
        let html = "";
        if (this.floatBarController.config.display_options){
            html +=`
                <!-- GRID, MEASURES AND BAKCGROUND -->
                <button id="grille" title="Afficher/Masquer la grille" type="button" class="btn btn-flat btn-default height-low-priority-2">
                        <i class="material-icons icon-FloatBar_Grid"></i></button>
                <div  class="tool-separator ghost mini"></div>

                <button id="mesures" title="Afficher/Masquer les mesures" type="button" class="btn btn-flat btn-default height-low-priority-2">
                    <i class="material-icons icon-FloatBar_MeterSquared"></i></button>
                <div class="tool-separator ghost mini"></div>
            `;
        }
        if (this.floatBarController.config.display_map) {
            html += `
            <!-- test -->
                <button id="paperplan" title="Afficher/Masquer le plan papier" type="button" class="btn btn-flat btn-default height-low-priority-2"
                    style="padding-top: 2px!important;">
                    <i class="fa-regular fa-image"></i></button>
                <div class="tool-separator" style="display:${this.floatBarController.isDesigner ? '' : 'none'}"></div>
            `
        } else if (this.floatBarController.config.display_options){
            html += `<div class="tool-separator" style="display:${this.floatBarController.isDesigner ? '' : 'none'}"></div>`
        }
        return html;
    }

    ManageImports(): string {
        if (this.floatBarController.config.display_download_upload){
            return `
                <div>
                    <span id="importButton" class="dropdown" style="display:${this.floatBarController.isDesigner ? "" : 'none'}">
                        <button title="Imports" style="padding:0!important;" class="btn btn-flat btn-default">
                            <i class="material-icons icon-Import"></i>
                        </button>
                        <ul id="importMenu" class="dropdown-menu" role="menuExport" style="width:200px;margin-left:20px;margin-top:-55px;display:none">
                            <button id="importProject" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Tout un projet</button>
                            <button id="importCameras" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Caméras à l'étage courant</button>
                            <button id="importCurrentFloor" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px">Sélection à l'étage courant</button>
                        </ul>
                    </span>
                </div>

                <div>
                    <span id="exportButton" class="dropdown" style="display:${this.floatBarController.isDesigner ? "" : 'none'}">
                        <button title="Exports" style="padding:0!important;" class="btn btn-flat btn-default">
                            <i class="material-icons icon-Import  inversed"></i>
                        </button>
                        <ul id="exportMenu" class="dropdown-menu" role="menuExport" style="width:200px;margin-left:20px;margin-top:-170px;display:none">
                            <button id="exportDefault" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Tout le projet</button>
                            <button id="exportWithoutDeco" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Sans décoration</button>
                            <button id="exportWithoutDecoKitchen" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Avec cuisine seulement</button>
                            <button id="exportCameras" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Caméras de l'étage</button>
                            <button id="exportSelected" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px;margin-bottom:2px">Sélection</button>
                            <button id="exportSelectedWithoutswitch" class="btn btn-flat btn-primary borderless" style="background:#286090;width:200px">Sélection sans interrupteur</button>
                        </ul>
                    </span>
                </div>
            `;
        }
        return "";
    }

    ManageGeometricTool(): string {
        if (!this.floatBarController.config.transformations) return "";
        return `
            <!-- GEOMETRIC TRANSFO -->
                <span id="geometricButton" class="dropdown">
                    <button title="Transformations géométriques" style="padding:0!important;" class="btn btn-flat btn-default">
                        <i class="material-icons icon-FloatBar_Transformations"></i>
                    </button>
                    <ul id="geometricMenu" class="dropdown-menu dropdown-menu-large" role="menuTransformation" style="margin-left:20px;display:none">
                        <li id="closeGeometric" class="clearfix" style="padding-top:12px;margin-left:30px;">Transformations géométriques de projets<a class="icon-Close pull-right"></a></li>
                        <div class="dropdown">

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Translation
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            de
                            <input id="translateXInput" style="width:20%;height:28px;display:inline-block" class="form-control" type="number">
                            cm en X et de
                            <input id="translateYInput" style="width:20%;height:28px;display:inline-block" class="form-control" type="number">
                            cm en Y
                            <button id="applyTranslate" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Go !</button>
                        </div>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Symétrie
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            <!-- We (programers) talk about symetry horz but for graphic artists, this means symetry with the vertical axis -->
                            <button id="symetryHorizontal" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Symétrie horizontale</button>
                            <!-- We (programers) talk about symetry vert but for graphic artists, this means symetry with the horizontal axis -->
                            <button id="symetryVertical" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Symétrie verticale</button>
                        </div>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Rotation
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            de
                            <input id="rotateInput" style="width:20%;height:28px;display:inline-block" class="form-control" type="number">
                            °
                            <button id="applyRotate" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Go !</button>
                        </div>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Agrandissement
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            à
                            <input id="scaleInput" style="width:20%;height:28px;display:inline-block" class="form-control" type="number">
                            % du project actuel
                            <button id="applyScale" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Go !</button>
                        </div>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Hauteur de plafonds
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            à
                            <input id="floorHeightInput" style="width:20%;height:28px;display:inline-block" class="form-control" type="number">
                            cm
                            <button id="applyHeight" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Etage courant</button>
                            <button id="applyHeightProject" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Tout le projet</button>
                        </div>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Surélever toutes les pièces de
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            de
                            <input id="roomfloorHeightInput" style="width:20%;height:28px;display:inline-block" class="form-control" type="number">
                            cm
                            <button id="applyFloorHeight" class="btn btn-flat btn-primary borderless" style="background:#286090;height:28px;vertical-align:unset">Etage courant</button>
                        </div>

                        <div style="margin-bottom:10px"></div>
                        </div>
                    </ul>
                </span>
                <div class="tool-separator"></div>
        `
    }

    ManageGeometricAdd(): string {
        if (!this.floatBarController.config.add_geometric) return "";

        return `
            <!-- GEOMETRIC TRANSFORMATIONS -->
            <span id="geometricButton" class="dropdown">
                <button title="Transformations géométriques" class="btn btn-flat btn-default" style="padding: 0 !important;">
                    <i class="material-icons icon-FloatBar_Transformations"></i>
                </button>

                <ul id="geometricMenu" class="dropdown-menu dropdown-menu" role="menu" style="margin-left: 20px;display: none;width: 330px;padding: 0;">
                    <li id="closeGeometric" class="clearfix" style=" padding: 12px 15px;margin: 0;border-bottom: 1px solid #ddd;">
                        <span>Ajouter une forme géométrique :</span>
                        <a class="icon-Close pull-right"></a>
                    </li>

                    <div style="display: grid;grid-template-columns: repeat(3, 1fr);gap: 8px;padding: 12px;">
                        <div id="add_box" class="geometric-tool" data-type="box">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Square"></div>
                            </div>
                            <div class="plan-tool-title">Boîte</div>
                        </div>

                        <div id="add_cylinder" class="geometric-tool" data-type="cylinder">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Cylinder"></div>
                            </div>
                            <div class="plan-tool-title">Cylindre</div>
                        </div>

                        <div id="add_oval" class="geometric-tool" data-type="oval">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Square"></div>
                            </div>
                            <div class="plan-tool-title">Ovale</div>
                        </div>

                        <div id="add_triangle" class="geometric-tool" data-type="triangle">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Square"></div>
                            </div>
                            <div class="plan-tool-title">Triangle</div>
                        </div>

                        <div id="add_sphere" class="geometric-tool" data-type="sphere">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Cylinder"></div>
                            </div>
                            <div class="plan-tool-title">Sphère</div>
                        </div>

                        <div id="add_hood" class="geometric-tool" data-type="hood">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Square"></div>
                            </div>
                            <div class="plan-tool-title">Hotte</div>
                        </div>

                        <div id="add_halfarc" class="geometric-tool" data-type="halfarc">
                            <div class="sub-sub-plan-tool">
                                <div class="plan-tool-icon icon-GeomPrim_Square"></div>
                            </div>
                            <div class="plan-tool-title">Demi-arche</div>
                        </div>
                    </div>
                </ul>
            </span>

            <div class="tool-separator"></div>
        `;
    }
    

    ManageGeneralParam(): string {
        if (this.floatBarController.config.display_config) {
            return `
                <!-- GENERAL PARAMS -->
                <span id="generalButton" class="dropdown">
                    <button title= "Paramètres généraux" style="padding:0!important;" class="btn btn-flat btn-default">
                        <i class="material-icons icon-Tulip_Wheel"></i>
                    </button>
                    <ul id="generalMenu" class="dropdown-menu dropdown-menu-large" role="menu" style="margin-left:20px;margin-top:-50px;display:none">
                        <li id="closeSettings" class="clearfix" style="padding-top:12px;margin-left:30px">Paramètres généraux<a class="icon-Close pull-right"></a></li>
                        <div class="dropdown">

                        <div class="hr-small"></div>

                        <input id="vectorDraw" type="checkbox" ${PlanManager.getInstance().vectorDraw ? "checked" : "" } class="togglebuttonVectorDraw" style="margin-left:160px;margin-bottom:10px">    Tracé vectoriel</input>

                        <div style="margin-left:30px;font-size:12px">
                            Opacité du plan
                        </div>
                        <input style="outline-width:0px" id="opacityInput" min="0" max="255" type="range">
                        <div style="margin-left:30px;font-size:12px">
                            Opacité de l'étage inférieur
                        </div>
                        <input style="outline-width:0px" id="opacityFloorsInput" min="0" max="255" type="range">
                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Couleurs par défaut des menuiseries
                        </div>
                        <div style="height:30px;width:85%;margin-left:30px;margin-right: 20px;">
                            <select id="selectJoineryColor" class="form-control dropDownObjectType ${this.floatBarController.joineryDefaultColor === undefined ? "greyText" : ""}"
                                style="background-color : #fff!important;font-size : 11px!important;height : 30px!important;border : 1px solid #ccc!important">
                                ${this.ManageJoineryColor()}
                            </select>
                        </div>
                        <button id="applyIndoor"class="btn btn-flat btn-primary borderless" style="background:#286090;margin-bottom:0px;margin-left:30px;margin-top:2px">Appliquer projet intérieurs</button>
                        <button id="applyOutdoor" class="btn btn-flat btn-primary borderless" style="background:#286090;margin-bottom:0px;margin-top:2px">Appliquer projet extérieurs</button>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Objets 3D posés dans le plan
                        </div>
                        <div style="height:30px;width:85%;margin-bottom:2px;margin-left:30px">
                            <select id="selectObject" class="form-control dropDownObjectType ${this.floatBarController.currentObjectType === undefined ? "greyText" : ""}"
                                style="background-color : #fff!important;font-size : 11px!important;height : 30px!important;border : 1px solid #ccc!important">
                                ${this.ManageObjects()}
                            </select>
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            Modèle 3D par défaut
                        </div>
                        <div>
                            <img id="previewImg" style="width:75px;height:75px;margin-left:30px" src="${this.floatBarController.itemPreview}"/>
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            Modèles disponibles
                        </div>
                        <div id="modeleManage" style="margin-left:30px;margin-bottom:2px;white-space:nowrap;width:85%;height:95px;overflow-x:auto;">
                            ${this.ManageModeleChoice()}

                        </div>

                        <div style="margin-left:30px;font-size:12px">
                            <button id="resetModele" class="btn btn-flat btn-primary borderless" style="background:#286090;margin-bottom:2px">Réinitialiser modèles par défaut</button>
                        </div>

                        <div class="hr-small"></div>

                        <div style="margin-left:30px;font-size:12px">
                            Corniches
                        </div>
                        <div style="margin-left:30px;font-size:12px">
                            <button id="activateCurrentFloor" class="btn btn-flat btn-primary borderless" style="background:#286090;margin-bottom:2px">Activer à l'étage courant</button>
                            <button id="deactivateCurrentFloor" class="btn btn-flat btn-primary borderless" style="background:#286090;margin-bottom:2px">Désactiver à l'étage courant</button>
                            <button id="activateProject" class="btn btn-flat btn-primary borderless" style="background:#286090">Activer sur tout le projet</button>
                            <button id="deactivateProject" class="btn btn-flat btn-primary borderless" style="background:#286090">Désactiver sur tout le projet</button>
                        </div>

                        <div style="margin-bottom:10px"></div>
                        </div>
                    </ul>
                </span>
                <div class="tool-separator"></div>
            `;
        }
        return "";
    }

    ManageModeleChoice(): string {
        let html = "";
        this.floatBarController.allModelsForCurrentElement.forEach((modele, index) =>{
            html += `
                <img id="modele-${index}" style="display: inline-block;width:75px;height:75px;margin-right:4px;" src="${this.floatBarController.getPreviewUrl(modele)}"></img>
            `
        })
        return html;
    }

    ManageJoineryColor(): string {
        let html = "";
        this.floatBarController.allJoineryColors.forEach(joineryColor =>{
            html += `
                <option class="drop_down_option" value="${joineryColor.value}">
                    ${joineryColor.name}
                </option>
            `
        })
        return html;
    }

    ManageObjects(): string {
        let html = "";
        this.floatBarController.allObjects.forEach(object =>{
            html += `
                <option class="drop_down_option" value="${object.value}">
                    ${object.name}
                </option>
            `
        })
        return html;
    }

    ManageZoom(): string {
        if (this.floatBarController.config.zoom) {
            return `
                <!-- ZOOM -->
                <div class="tool-zoombox height-low-priority-1 vertical-container">
                    <button id="zoomIn" type="button" title="Zoom +" class="btn btn-flat btn-default" style="margin-bottom:8px;">
                        <i style="font-size:10px;font-weight:900;" class="material-icons icon-FloatBar_Plus"></i></button>
                    <div class="material-icons icon-FloatBar_Lens"></div>

                    <button id="zoomOut" type="button" title="Zoom -" class="btn btn-flat btn-default">
                        <i style="font-size:14px;">_</i>
                    </button>
                </div>
                ${this.floatBarController.config.fullscreen ? `<div class="tool-separator height-low-priority-1"></div>` : ""}
            `;
        }
        return "";       
    }

    ManageCustom(): string {
        let html = "";
        if (!this.floatBarController.config.customs) return html;
        this.floatBarController.config.customs.forEach((custom: any, index: number) => {
            if ((custom.for_designer && this.floatBarController.isDesigner) || (!custom.for_designer && !this.floatBarController.isDesigner)) {
                html += `
                    <div class="tool-separator"></div>
                    <button id="custom-${index}" type="button" title="Télécharger la coque" class="btn btn-flat btn-default">
                        <i class="${custom.icon}"></i>
                    </button>
                `;
            }
        });
        return html;
    }
}
          